import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useTheme } from '../../contexts/themeContext'

const Avatar = styled('div')(({ size, fontSize }) => ({
  fontSize,
  width: `${size}em`,
  height: `${size}em`,
  borderRadius: '50%',
  background: '#555555',
  color: '#ffffff',
  display: 'inline-flex',
  fontWeight: 'bold',
  alignItems: 'center',
  justifyContent: 'center',
  '&:after': {
    content: 'attr(data-label)',
    color: 'currentColor',
  },
}))

// Accept both unitless (5, '16') and full CSS values ('5px', '1rem')
const resolveFontSize = (value) =>
  /^\d*\.?\d+$/.test(String(value)) ? `${value}px` : value

export const AvatarImg = styled('img')(({ size, theme }) => ({
  height: `${size}em`,
  width: `${size}em`,
  backgroundColor: theme.gray300,
  padding: '3px',
  borderRadius: '50%',
}))

export default function ProfileAvatar({
  name = null,
  picture = null,
  size = 2.2,
  fontSize = '16',
  style = {},
}) {
  const { theme } = useTheme()

  const getInitials = (_name) => {
    const firstInitial = _name.split(' ')[0].charAt(0).toUpperCase()
    if (_name.split(' ').length === 1) {
      return `${firstInitial}`
    }
    const secondInitial = _name.split(' ')[1]?.charAt(0).toUpperCase()
    return `${firstInitial}${secondInitial}`
  }

  if (picture) {
    return <AvatarImg src={picture} alt={name} size={size} style={style} />
  }
  if (name) {
    return (
      <Avatar
        data-label={getInitials(name)}
        style={{
          backgroundColor: theme.brandColorOrange,
          color: theme.buttonTextColor,
          ...style,
        }}
        size={size}
        fontSize={resolveFontSize(fontSize)}
      />
    )
  }
  return <Avatar data-label="" />
}

ProfileAvatar.propTypes = {
  name: PropTypes.string,
  picture: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
}
